import fr from './fr.json';
import en from './en.json';
import es from './es.json';
import pt from './pt.json';
import it from './it.json';
import de from './de.json';

const messages = {
  fr,
  en,
  es,
  pt,
  it,
  de
};
export default messages;